// ** IMPORTANT **: Keep in sync with functions/src/index.ts
export enum POST_ACCESS_ITEM_SCOPE {
    full = 'full',
    limited = 'limited',
}
